import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import Button from '../../../shared/button';
import { put } from 'helpers/api';

export const ConfirmListingIsUpToDateModal = ({
  channels,
  daysWithoutUpdate,
  needsConfirmation,
  projectDisplayName,
  syndicationTouchPath,
  onEditProperty
}) => {
  const [show, setShow] = useState(needsConfirmation);
  const [isSaving, setIsSaving] = useState(false);

  const touchPropertyForSyndication = () => {
    setIsSaving(true);

    put(syndicationTouchPath)
      .then(() => {
        setIsSaving(false);
        setShow(false);
      })
      .catch(() => {
        setIsSaving(false);
      });
  };

  return (
    <Modal bsSize="sm" show={show} onHide={() => setShow(false)}>
      <Modal.Body className="modal-padding">
        <div className="d-flex justify-content-center mb-5">
          <FontAwesomeIcon className="icon-gradient" icon={faExclamationCircle} size="3x" />
        </div>
        <h3 className="my-5 bold text-center">Would you like to keep syndicating?</h3>
        <p className="spaced-text mb-5">
          <b>{projectDisplayName} has not been updated in the last {daysWithoutUpdate} days.</b> To ensure
          continued visibility on syndication sites, please take a moment to
          update your listing's details. Incomplete information may result in the
          removal from the following syndication channels:
        </p>

        <ul className="mb-5">
          {channels?.map((channel, i) => <li key={i}>{channel}</li>)}
        </ul>

        <div className="mt-4 d-flex justify-content-center">
          <Button.Primary className="mr-2" disabled={isSaving} outlined onClick={onEditProperty}>
            Edit Listing
          </Button.Primary>
          <Button.Primary disabled={isSaving} onClick={() => touchPropertyForSyndication()}>
            Yes, keep syndicating
          </Button.Primary>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmListingIsUpToDateModal;

ConfirmListingIsUpToDateModal.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.string),
  daysWithoutUpdate: PropTypes.number.isRequired,
  needsConfirmation: PropTypes.bool,
  projectDisplayName: PropTypes.string.isRequired,
  syndicationTouchPath: PropTypes.string.isRequired,
  onEditProperty: PropTypes.func.isRequired
};
